export default {
  getPublicQuestions(state) {
    return state.publicQuestions;
  },
  getTeamQuestions(state) {
    return state.teamQuestions;
  },
  getTeamLabels(state) {
    return state.teamLabels;
  },
};
